jQuery(document).ready(function($){

  const contactFlyoutButton = $('#contact-flyout-button');
  const isLandingPage = $('body').hasClass('page-template-landing-page');

  /**
   * Disables top-level menu items from being click-able if they have children
   */
  $(contactFlyoutButton).on('click',function(e){
    if(isLandingPage){
      e.preventDefault();
      let scrollLocation = window.scrollY + document.querySelector('#gform_wrapper_1').getBoundingClientRect().top;
      console.log(scrollLocation);
      window.scrollTo(0,scrollLocation - 150);

      //Stop the drawer from opening
      e.stopImmediatePropagation();
    }
  });
});


// WEBPACK FOOTER //
// ./assets/js/contact-flyout.js